module.exports = __webpack_public_path__ + "static/media/result_popup_close.a7f52018.svg";